import React, { Component } from 'react'
import { setup } from 'bem-cn'
import { ReactComponent as Illustration } from '../../images/calendars-cat.svg'
import { withI18n } from 'react-i18next'

const block = setup({
    mod: '--'
})

const b = block('EmptyCalendar')

class EmptyCalendar extends Component {
    render() {
        const { t } = this.props
        return (
            <div className={b()}>
                <div className={b('illustration')}>
                    <Illustration />
                </div>
                <div className={b('text')}>{t('calendar:Please select a calendar')}</div>
            </div>
        )
    }
}

export default withI18n()(EmptyCalendar)
